__turbopack_context__.v({
  "heading": "kOIHDW_heading",
  "high": "kOIHDW_high",
  "low": "kOIHDW_low",
  "medium": "kOIHDW_medium",
  "snowDays": "kOIHDW_snowDays",
  "snowHeight": "kOIHDW_snowHeight",
  "winter": "kOIHDW_winter",
});
